export enum AppointmentStatus {
  TODO = 'TODO',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED',
}
